if (!customElements.get('product-upsells')) {
  class ProductUpsells extends HTMLElement {
    constructor() {
      super();
      this.checkboxes = this.querySelectorAll('.product-upsells-checkboxes__checkbox');
      this.mainProductId = this.dataset.mainProductId;
      this.basePrice = 0;
      this.baseCompareAtPrice = 0;

      // Initialiser les prix de base
      this.initBasePrices();

      // Ajouter les écouteurs d'événements
      this.addEventListeners();

      // Initialiser ou récupérer la structure de données pour les upsells
      if (!window.selectedUpsells) {
        window.selectedUpsells = {};
      }

      // Initialiser l'ensemble pour ce produit principal s'il n'existe pas déjà
      if (!window.selectedUpsells[this.mainProductId]) {
        window.selectedUpsells[this.mainProductId] = new Set();
      }
    }

    initBasePrices() {
      const priceElement = document.querySelector('[data-product-price]');
      const compareAtPriceElement = document.querySelector('[data-product-compare-price]');

      if (priceElement) {
        // Extraire le prix sans le formatage monétaire
        const priceText = priceElement.textContent.trim();
        this.basePrice = this.extractPrice(priceText);
      }

      if (compareAtPriceElement && compareAtPriceElement.style.display !== 'none') {
        const compareAtPriceText = compareAtPriceElement.textContent.trim();
        this.baseCompareAtPrice = this.extractPrice(compareAtPriceText);
      } else {
        this.baseCompareAtPrice = 0;
      }
    }

    extractPrice(priceText) {
      if (!priceText) return 0;

      // Extraire uniquement les chiffres et la virgule/point décimal
      const priceMatch = priceText.match(/[\d\.,]+/g);
      if (priceMatch && priceMatch.length > 0) {
        // Convertir en nombre en supprimant les séparateurs de milliers et en remplaçant la virgule par un point
        let price = priceMatch[0];

        // Gérer différents formats de prix (1.234,56 € ou 1,234.56 €)
        if (price.indexOf(',') > price.indexOf('.') && price.indexOf('.') !== -1) {
          // Format 1.234,56
          price = price.replace(/\./g, '').replace(',', '.');
        } else {
          // Format 1,234.56 ou 1234,56
          price = price.replace(/,/g, '.');
        }

        return parseFloat(price);
      }
      return 0;
    }

    addEventListeners() {
      // Écouter les changements de case à cocher
      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      });

      // Écouter les changements de variante
      document.addEventListener('variant:changed', this.handleVariantChanged.bind(this));
    }

    handleCheckboxChange(event) {
      const checkbox = event.target;
      const variantId = checkbox.dataset.variantId;
      const mainProductId = checkbox.dataset.mainProductId || this.mainProductId;

      if (checkbox.checked) {
        window.selectedUpsells[mainProductId].add(variantId);
      } else {
        window.selectedUpsells[mainProductId].delete(variantId);
      }

      this.updatePrices();
    }

    handleVariantChanged(event) {
      // Mettre à jour les prix de base avec la nouvelle variante
      this.initBasePrices();

      // Recalculer les prix avec les upsells sélectionnés
      this.updatePrices();
    }

    updatePrices() {
      let totalPrice = this.basePrice;
      let totalCompareAtPrice = this.baseCompareAtPrice;

      // Ajouter le prix de chaque upsell sélectionné pour ce produit principal
      this.checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          const price = parseFloat(checkbox.dataset.price) / 100; // Convertir en euros
          totalPrice += price;

          const compareAtPrice = parseFloat(checkbox.dataset.compareAtPrice);
          if (compareAtPrice && compareAtPrice > 0) {
            totalCompareAtPrice += compareAtPrice / 100;
          }
        }
      });

      // Mettre à jour tous les éléments de prix dans le DOM
      document.querySelectorAll('[data-product-price]').forEach((el) => {
        el.innerHTML = this.formatMoney(totalPrice);
      });

      document.querySelectorAll('[data-product-compare-price]').forEach((el) => {
        if (totalCompareAtPrice > 0 && totalCompareAtPrice > totalPrice) {
          el.innerHTML = this.formatMoney(totalCompareAtPrice);
          el.style.display = 'inline';
        } else {
          el.style.display = 'none';
        }
      });
    }

    formatMoney(amount) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  customElements.define('product-upsells', ProductUpsells);
}
